export const catalogConfigs = {
  title: {
    default: "PLATFORMBASE",
    ko: "플랫폼베이스",
  },
  langSet: ["en", "ko"],
  pageMap: {
    en: [
      { name: "cover" },
      { name: "catalog-index" },
      { name: "platform-intro" },
      { name: "platform-overview" },
      { name: "platform-features" },
      { name: "platform-applications" },
      { name: "platform-cases", outlets: ["1", "2", "3"] },
      { name: "product-intro", outlets: ["one-key", "multi-user"] },
      { name: "product-digital-key" },
      { name: "product-digital-lock" },
      { name: "product-lineup" },
      { name: "manual", outlets: ["1", "2", "3", "4", "5", "6", "7", "8"] },
      { name: "company-vision" },
      { name: "company-history", outlets: ["1", "2"] },
      { name: "company-certificate" },
      { name: "company-partners" },
      { name: "last" },
    ],
    ko: [
      { name: "cover" },
      { name: "catalog-index" },
      { name: "platform-intro" },
      { name: "platform-overview" },
      { name: "platform-features" },
      { name: "platform-applications" },
      { name: "platform-cases", outlets: ["1", "2", "3"] },
      { name: "product-intro", outlets: ["one-key", "multi-user"] },
      { name: "product-digital-key" },
      { name: "product-digital-lock" },
      { name: "product-lineup" },
      { name: "manual", outlets: ["1", "2", "3", "4", "5", "6", "7", "8"] },
      { name: "company-vision" },
      { name: "company-history" },
      { name: "company-certificate" },
      { name: "company-partners" },
      { name: "last" },
    ],
  },
  autoplay: {
    delay: 4000,
    loop: true,
  },
  width: 1920,
  height: 1080,
  breakpoint: 0,
};

const ENV = process.env;
export const IS_DEV = ENV.REACT_APP_IS_DEV;
export const ROUTER_TYPE = ENV.REACT_APP_ROUTER_TYPE;
export const BASE_NAME = ENV.REACT_APP_BASE_NAME;
export const PUBLIC_URL = ENV.PUBLIC_URL;
export const IMG_URL = `${PUBLIC_URL}/images`;
